import { Injectable } from '@angular/core';
import { ProductionPlanningService } from '../../tools/services/production-planning.service';
import { BehaviorSubject } from 'rxjs';
import { GlobalFilter } from '../interfaces/global-filter-model';

@Injectable()
export class GlobalFilterService {
  private _currentFilter = undefined;
  private _dateRange = undefined;

  private _globalFilters = new BehaviorSubject<GlobalFilter>(null);
  public globalFilters = this._globalFilters.asObservable();

  private _filterMasterData = new BehaviorSubject<any>(null);
  public filterMasterData = this._filterMasterData.asObservable();

  private _lastRef = new BehaviorSubject<any>(null);
  public lastRef = this._lastRef.asObservable();

  constructor(
    private ppService: ProductionPlanningService) {
  }

  public loadFilterData(): void {
    const payload = {};
    this.ppService.fetchFilterData(payload).subscribe((filterMaster) => {
      this._dateRange = undefined;
      const clonedData = JSON.parse(JSON.stringify({ ...filterMaster }));
      this._filterMasterData.next(clonedData);
      this._lastRef.next(clonedData.refreshed_date);
    });
  }

  public updateGlobalFiltersSelection(selection: GlobalFilter) {
    this._currentFilter = selection;
    this._globalFilters.next(selection);
  }

  public updateDaterange(defaultDateRange) {
    this._dateRange = defaultDateRange;
  }

  public updateLastRefreshed(data) {
    this._lastRef.next(data);
  }

  public getFilterMasterData() {
    return this._filterMasterData.getValue();
  }

  public resetFilters() {
    this._globalFilters.next(null);
    this._filterMasterData.next(null);
  }

  public get currentFilters() {
    return this._currentFilter;
  }

  public get dateRangeDefault() {
    return this._dateRange;
  }
}
